var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      marginBottom: -2,
      marginRight: 5
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 3C5.42174 3 5.50652 3.03512 5.56904 3.09763C5.63155 3.16014 5.66667 3.24493 5.66667 3.33333V3.66667H11V3.33333C11 3.24493 11.0351 3.16014 11.0976 3.09763C11.1601 3.03512 11.2449 3 11.3333 3C11.4217 3 11.5065 3.03512 11.569 3.09763C11.6315 3.16014 11.6667 3.24493 11.6667 3.33333V3.66667H12.3333C12.687 3.66667 13.0261 3.80714 13.2761 4.05719C13.5262 4.30724 13.6667 4.64638 13.6667 5V12.3333C13.6667 12.687 13.5262 13.0261 13.2761 13.2761C13.0261 13.5262 12.687 13.6667 12.3333 13.6667H4.33333C3.97971 13.6667 3.64057 13.5262 3.39052 13.2761C3.14048 13.0261 3 12.687 3 12.3333V5C3 4.64638 3.14048 4.30724 3.39052 4.05719C3.64057 3.80714 3.97971 3.66667 4.33333 3.66667H5V3.33333C5 3.24493 5.03512 3.16014 5.09763 3.09763C5.16014 3.03512 5.24493 3 5.33333 3ZM3.80474 5.66667V12.1953C3.80474 12.3721 3.87498 12.5416 4 12.6667C4.12502 12.7917 4.29459 12.8619 4.4714 12.8619H12.1953C12.3721 12.8619 12.5416 12.7917 12.6667 12.6667C12.7917 12.5416 12.8619 12.3721 12.8619 12.1953V5.66667H3.80474Z",
    fill: "#8F8F8F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.86621,
    y: 6.66748,
    width: 2,
    height: 2,
    rx: 0.5,
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.28752c9ff585bb62135a80d8d25a061d.svg";
export { ForwardRef as ReactComponent };